import { getOrders } from '@/shared/api/orders';
import { useSentryAsync } from '@/shared/composition/useSentryAsync';
import { Order } from '@/shared/interfaces';
import { defineStore } from 'pinia';

const { captureExceptionSentry } = useSentryAsync();

export const useOrdersStore = defineStore('orders', {
  state: () => ({
    orders: [] as Order[],
    filters: {},
  }),
  actions: {
    setFilters(filters: any) {
      this.filters = filters;
    },
    async fetchOrders() {
      try {
        const orders = await getOrders(this.filters);
        this.orders = orders || [];
      } catch (error) {
        captureExceptionSentry(error, 'получение заказов');
      }
    },
  },
});
